import React, { useEffect, useState } from 'react'
import Input from '../../components/input';
import useAxiosInstance from '../../hooks/useAxios';
import JsonView from '@uiw/react-json-view';
import { toast } from 'react-toastify';

const PlaygroundV2Model = ({prompt_function,set_prompt_function, prompt_text,set_prompt_text, model,set_model,system_prompt,set_system_prompt,max_tokens,set_max_tokens }) => {
    const [model_parameters, set_model_parameters] = useState({})
    const axiosInstance = useAxiosInstance()
    const [model_label,set_model_label] = useState('');
        
    const [library,set_library] = useState('');
    const [library_options,set_library_options] = useState([]);
    
    const [provider,set_provider] = useState('');
    const [provider_options,set_provider_options] = useState([]);
    
    const [model_options,set_model_options] = useState([]);
    
    const [response, setResponse] = useState({});
    const [responseLoading,setResponseLoading] = useState(false);
    useEffect(()=>{
        axiosInstance.get('wkl/llm/get_library/').then(res=>
            set_library_options(res?.data?.data || [])
        ).catch()
    },[])
    
    useEffect(()=>{
        axiosInstance.get(`wkl/llm/get_provider/?library_pk=${library}`).then(res=>
            set_provider_options(res?.data?.data || [])
        ).catch()
    },[library])

    useEffect(()=>{
        axiosInstance.get(`wkl/llm/get_models/?provider_pk=${provider}`).then(res=>
            set_model_options(res?.data?.data || [])
        ).catch()
    },[provider])

    useEffect(()=>{
        if(!model_label && model){
            set_model_label(model.label)
        }
    },[model,model_label])

    return (
        <div className='mx-4 py-4 '>
            <p className='text-lg px-3 py-2 rounded-lg bg-white border w-full font-semibold'>Playground</p>
            <did className={'flex justify-between gap-x-3 bg-slate-100 pl-3 pr-6 pb-4 rounded-b-lg'}>
            <div className='min-w-[70%] mt-4'>
                
                <span className='text-sm font-semibold'>
                    System Prompt
                </span>
                <Input type='text__area' value={system_prompt} onChange={e=>set_system_prompt(e.target.value)}/>

                <span className='text-sm font-semibold'>
                    Prompt Text
                </span>
                <Input type='text__area' value={prompt_text} onChange={e=>set_prompt_text(e.target.value)}/>
                
                <div className='w-full flex justify-end'>
                <button
                className='text-base font-semibold px-3 py-2 bg-black rounded-lg text-white'
                onClick={()=>{
                    setResponseLoading(true)
                    axiosInstance.post('wkl/llm/make_llm_call/',
                        {
                            prompt_function:JSON.parse(prompt_function || '[]'),
                            prompt_text,
                            model_label,
                            system_prompt,
                            max_tokens
                        }
                    ).then(
                        response=>{
                            
                    setResponseLoading(false)
                            setResponse(response.data)}
                    )
                }}
                disabled={responseLoading}
                >Fire</button></div>
                <div className='bg-slate-200 p-3 mt-3 rounded-lg max-h-80 overflow-y-auto'>
                    {responseLoading ? 'loading...':
                    <JsonView
                    shortenTextAfterLength={0}
                    value={response}
                    displayObjectSize={false}
                    displayDataTypes={false}
                  />}
                </div>
            </div>
            <div className='min-w-[30%] mt-4'>
                <span className='text-sm font-semibold mb-3'>
                    Library
                </span>
                <select 
                className="border rounded-lg px-3 py-2 w-full focus:ring-0 focus:outline-gray-400 disabled:bg-gray-300"      
                value={library}
                onChange={(e)=>set_library(e.target.value)}
                >
                    <option value={''}>Choose</option>
                    {library_options.map(elem=>{return <option value={elem.pk}>{elem.label}</option>})}
                </select>

                <span className='text-sm font-semibold mb-3'>
                    Provider
                </span>
                <select 
                className="border rounded-lg px-3 py-2 w-full focus:ring-0 focus:outline-gray-400 disabled:bg-gray-300"      
                value={provider}
                onChange={(e)=>set_provider(e.target.value)}>
                   <option value={''}>Choose</option>
                    {provider_options.map(elem=>{return <option value={elem.pk}>{elem.label}</option>})}
                </select>

                <span className='text-sm font-semibold mb-3'>
                    Model
                </span>
                <select 
                className="border rounded-lg px-3 py-2 w-full focus:ring-0 focus:outline-gray-400 disabled:bg-gray-300"      
                value={model.label || ''}
                onChange={(e)=>{
                    const mdl = model_options.find(l=>l.label===e.target.value)
                    set_model(mdl)
                    set_max_tokens(mdl.max_tokens)
                    set_model_label(mdl.label)
                }}>
                   <option value={''}>Choose</option>
                    {model_options.map(elem=>{return <option value={elem.label}>{elem.label}</option>})}
                </select>

                <span className='text-sm font-semibold mb-3'>
                    Model Name
                </span>
                <Input type='text' value={model.model} disabled/>
                <span className='text-sm font-semibold mb-3'>
                    Timeout
                </span>
                <Input type='text' value={model.timeout} disabled/>
                <span className='text-sm font-semibold mb-3'>
                    Max tokens
                </span>
                <Input type='number' value={max_tokens} onChange={(e)=>{set_max_tokens(Number(e.target.value))}}/>
                <span className='text-sm font-semibold mb-3'>
                    Function
                </span>
                <Input type='text' value={prompt_function} onChange={(e)=>{set_prompt_function(e.target.value)}}/>
                
                <span className='text-sm font-semibold mb-3'>
                    Cost per input token
                </span>
                <Input type='text' value={model.cost_per_input_token} disabled/>
                <span className='text-sm font-semibold mb-3'>
                    Cost per output token
                </span>
                <Input type='text' value={model.cost_per_output_token} disabled/>
            </div >
            </did>
        </div>
    )
}

export default PlaygroundV2Model